//
// Copyright 2022 The Yorkie Authors. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.10.1 with parameter "target=ts,import_extension=none"
// @generated from file yorkie/v1/resources.proto (package yorkie.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yorkie/v1/resources.proto.
 */
export const file_yorkie_v1_resources: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_wrappers]);

/**
 * ///////////////////////////////////////
 * Messages for Snapshot               //
 * ///////////////////////////////////////
 *
 * @generated from message yorkie.v1.Snapshot
 */
export type Snapshot = Message<"yorkie.v1.Snapshot"> & {
  /**
   * @generated from field: yorkie.v1.JSONElement root = 1;
   */
  root?: JSONElement;

  /**
   * @generated from field: map<string, yorkie.v1.Presence> presences = 2;
   */
  presences: { [key: string]: Presence };
};

/**
 * Describes the message yorkie.v1.Snapshot.
 * Use `create(SnapshotSchema)` to create a new message.
 */
export const SnapshotSchema: GenMessage<Snapshot> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 0);

/**
 * ChangePack is a message that contains all changes that occurred in a document.
 * It is used to synchronize changes between clients and servers.
 *
 * @generated from message yorkie.v1.ChangePack
 */
export type ChangePack = Message<"yorkie.v1.ChangePack"> & {
  /**
   * @generated from field: string document_key = 1;
   */
  documentKey: string;

  /**
   * @generated from field: yorkie.v1.Checkpoint checkpoint = 2;
   */
  checkpoint?: Checkpoint;

  /**
   * @generated from field: bytes snapshot = 3;
   */
  snapshot: Uint8Array;

  /**
   * @generated from field: repeated yorkie.v1.Change changes = 4;
   */
  changes: Change[];

  /**
   * deprecated
   *
   * @generated from field: yorkie.v1.TimeTicket min_synced_ticket = 5;
   */
  minSyncedTicket?: TimeTicket;

  /**
   * @generated from field: bool is_removed = 6;
   */
  isRemoved: boolean;

  /**
   * @generated from field: yorkie.v1.VersionVector version_vector = 7;
   */
  versionVector?: VersionVector;
};

/**
 * Describes the message yorkie.v1.ChangePack.
 * Use `create(ChangePackSchema)` to create a new message.
 */
export const ChangePackSchema: GenMessage<ChangePack> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 1);

/**
 * @generated from message yorkie.v1.Change
 */
export type Change = Message<"yorkie.v1.Change"> & {
  /**
   * @generated from field: yorkie.v1.ChangeID id = 1;
   */
  id?: ChangeID;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: repeated yorkie.v1.Operation operations = 3;
   */
  operations: Operation[];

  /**
   * @generated from field: yorkie.v1.PresenceChange presence_change = 4;
   */
  presenceChange?: PresenceChange;
};

/**
 * Describes the message yorkie.v1.Change.
 * Use `create(ChangeSchema)` to create a new message.
 */
export const ChangeSchema: GenMessage<Change> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 2);

/**
 * @generated from message yorkie.v1.ChangeID
 */
export type ChangeID = Message<"yorkie.v1.ChangeID"> & {
  /**
   * @generated from field: uint32 client_seq = 1;
   */
  clientSeq: number;

  /**
   * @generated from field: int64 server_seq = 2;
   */
  serverSeq: bigint;

  /**
   * @generated from field: int64 lamport = 3;
   */
  lamport: bigint;

  /**
   * @generated from field: bytes actor_id = 4;
   */
  actorId: Uint8Array;

  /**
   * @generated from field: yorkie.v1.VersionVector version_vector = 5;
   */
  versionVector?: VersionVector;
};

/**
 * Describes the message yorkie.v1.ChangeID.
 * Use `create(ChangeIDSchema)` to create a new message.
 */
export const ChangeIDSchema: GenMessage<ChangeID> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 3);

/**
 * @generated from message yorkie.v1.VersionVector
 */
export type VersionVector = Message<"yorkie.v1.VersionVector"> & {
  /**
   * @generated from field: map<string, int64> vector = 1;
   */
  vector: { [key: string]: bigint };
};

/**
 * Describes the message yorkie.v1.VersionVector.
 * Use `create(VersionVectorSchema)` to create a new message.
 */
export const VersionVectorSchema: GenMessage<VersionVector> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 4);

/**
 * @generated from message yorkie.v1.Operation
 */
export type Operation = Message<"yorkie.v1.Operation"> & {
  /**
   * @generated from oneof yorkie.v1.Operation.body
   */
  body: {
    /**
     * @generated from field: yorkie.v1.Operation.Set set = 1;
     */
    value: Operation_Set;
    case: "set";
  } | {
    /**
     * @generated from field: yorkie.v1.Operation.Add add = 2;
     */
    value: Operation_Add;
    case: "add";
  } | {
    /**
     * @generated from field: yorkie.v1.Operation.Move move = 3;
     */
    value: Operation_Move;
    case: "move";
  } | {
    /**
     * @generated from field: yorkie.v1.Operation.Remove remove = 4;
     */
    value: Operation_Remove;
    case: "remove";
  } | {
    /**
     * @generated from field: yorkie.v1.Operation.Edit edit = 5;
     */
    value: Operation_Edit;
    case: "edit";
  } | {
    /**
     * @generated from field: yorkie.v1.Operation.Style style = 7;
     */
    value: Operation_Style;
    case: "style";
  } | {
    /**
     * @generated from field: yorkie.v1.Operation.Increase increase = 8;
     */
    value: Operation_Increase;
    case: "increase";
  } | {
    /**
     * @generated from field: yorkie.v1.Operation.TreeEdit tree_edit = 9;
     */
    value: Operation_TreeEdit;
    case: "treeEdit";
  } | {
    /**
     * @generated from field: yorkie.v1.Operation.TreeStyle tree_style = 10;
     */
    value: Operation_TreeStyle;
    case: "treeStyle";
  } | {
    /**
     * @generated from field: yorkie.v1.Operation.ArraySet array_set = 11;
     */
    value: Operation_ArraySet;
    case: "arraySet";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message yorkie.v1.Operation.
 * Use `create(OperationSchema)` to create a new message.
 */
export const OperationSchema: GenMessage<Operation> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 5);

/**
 * @generated from message yorkie.v1.Operation.Set
 */
export type Operation_Set = Message<"yorkie.v1.Operation.Set"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket parent_created_at = 1;
   */
  parentCreatedAt?: TimeTicket;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: yorkie.v1.JSONElementSimple value = 3;
   */
  value?: JSONElementSimple;

  /**
   * @generated from field: yorkie.v1.TimeTicket executed_at = 4;
   */
  executedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.Operation.Set.
 * Use `create(Operation_SetSchema)` to create a new message.
 */
export const Operation_SetSchema: GenMessage<Operation_Set> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 5, 0);

/**
 * @generated from message yorkie.v1.Operation.Add
 */
export type Operation_Add = Message<"yorkie.v1.Operation.Add"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket parent_created_at = 1;
   */
  parentCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket prev_created_at = 2;
   */
  prevCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.JSONElementSimple value = 3;
   */
  value?: JSONElementSimple;

  /**
   * @generated from field: yorkie.v1.TimeTicket executed_at = 4;
   */
  executedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.Operation.Add.
 * Use `create(Operation_AddSchema)` to create a new message.
 */
export const Operation_AddSchema: GenMessage<Operation_Add> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 5, 1);

/**
 * @generated from message yorkie.v1.Operation.Move
 */
export type Operation_Move = Message<"yorkie.v1.Operation.Move"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket parent_created_at = 1;
   */
  parentCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket prev_created_at = 2;
   */
  prevCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 3;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket executed_at = 4;
   */
  executedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.Operation.Move.
 * Use `create(Operation_MoveSchema)` to create a new message.
 */
export const Operation_MoveSchema: GenMessage<Operation_Move> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 5, 2);

/**
 * @generated from message yorkie.v1.Operation.Remove
 */
export type Operation_Remove = Message<"yorkie.v1.Operation.Remove"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket parent_created_at = 1;
   */
  parentCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 2;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket executed_at = 3;
   */
  executedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.Operation.Remove.
 * Use `create(Operation_RemoveSchema)` to create a new message.
 */
export const Operation_RemoveSchema: GenMessage<Operation_Remove> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 5, 3);

/**
 * @generated from message yorkie.v1.Operation.Edit
 */
export type Operation_Edit = Message<"yorkie.v1.Operation.Edit"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket parent_created_at = 1;
   */
  parentCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TextNodePos from = 2;
   */
  from?: TextNodePos;

  /**
   * @generated from field: yorkie.v1.TextNodePos to = 3;
   */
  to?: TextNodePos;

  /**
   * deprecated
   *
   * @generated from field: map<string, yorkie.v1.TimeTicket> created_at_map_by_actor = 4;
   */
  createdAtMapByActor: { [key: string]: TimeTicket };

  /**
   * @generated from field: string content = 5;
   */
  content: string;

  /**
   * @generated from field: yorkie.v1.TimeTicket executed_at = 6;
   */
  executedAt?: TimeTicket;

  /**
   * @generated from field: map<string, string> attributes = 7;
   */
  attributes: { [key: string]: string };
};

/**
 * Describes the message yorkie.v1.Operation.Edit.
 * Use `create(Operation_EditSchema)` to create a new message.
 */
export const Operation_EditSchema: GenMessage<Operation_Edit> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 5, 4);

/**
 * @generated from message yorkie.v1.Operation.Style
 */
export type Operation_Style = Message<"yorkie.v1.Operation.Style"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket parent_created_at = 1;
   */
  parentCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TextNodePos from = 2;
   */
  from?: TextNodePos;

  /**
   * @generated from field: yorkie.v1.TextNodePos to = 3;
   */
  to?: TextNodePos;

  /**
   * @generated from field: map<string, string> attributes = 4;
   */
  attributes: { [key: string]: string };

  /**
   * @generated from field: yorkie.v1.TimeTicket executed_at = 5;
   */
  executedAt?: TimeTicket;

  /**
   * deprecated
   *
   * @generated from field: map<string, yorkie.v1.TimeTicket> created_at_map_by_actor = 6;
   */
  createdAtMapByActor: { [key: string]: TimeTicket };

  /**
   * @generated from field: repeated string attributes_to_remove = 7;
   */
  attributesToRemove: string[];
};

/**
 * Describes the message yorkie.v1.Operation.Style.
 * Use `create(Operation_StyleSchema)` to create a new message.
 */
export const Operation_StyleSchema: GenMessage<Operation_Style> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 5, 5);

/**
 * @generated from message yorkie.v1.Operation.Increase
 */
export type Operation_Increase = Message<"yorkie.v1.Operation.Increase"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket parent_created_at = 1;
   */
  parentCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.JSONElementSimple value = 2;
   */
  value?: JSONElementSimple;

  /**
   * @generated from field: yorkie.v1.TimeTicket executed_at = 3;
   */
  executedAt?: TimeTicket;

  /**
   * @generated from field: string actor = 4;
   */
  actor: string;
};

/**
 * Describes the message yorkie.v1.Operation.Increase.
 * Use `create(Operation_IncreaseSchema)` to create a new message.
 */
export const Operation_IncreaseSchema: GenMessage<Operation_Increase> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 5, 6);

/**
 * @generated from message yorkie.v1.Operation.TreeEdit
 */
export type Operation_TreeEdit = Message<"yorkie.v1.Operation.TreeEdit"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket parent_created_at = 1;
   */
  parentCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TreePos from = 2;
   */
  from?: TreePos;

  /**
   * @generated from field: yorkie.v1.TreePos to = 3;
   */
  to?: TreePos;

  /**
   * deprecated
   *
   * @generated from field: map<string, yorkie.v1.TimeTicket> created_at_map_by_actor = 4;
   */
  createdAtMapByActor: { [key: string]: TimeTicket };

  /**
   * @generated from field: repeated yorkie.v1.TreeNodes contents = 5;
   */
  contents: TreeNodes[];

  /**
   * @generated from field: int32 split_level = 7;
   */
  splitLevel: number;

  /**
   * @generated from field: yorkie.v1.TimeTicket executed_at = 6;
   */
  executedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.Operation.TreeEdit.
 * Use `create(Operation_TreeEditSchema)` to create a new message.
 */
export const Operation_TreeEditSchema: GenMessage<Operation_TreeEdit> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 5, 7);

/**
 * @generated from message yorkie.v1.Operation.TreeStyle
 */
export type Operation_TreeStyle = Message<"yorkie.v1.Operation.TreeStyle"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket parent_created_at = 1;
   */
  parentCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TreePos from = 2;
   */
  from?: TreePos;

  /**
   * @generated from field: yorkie.v1.TreePos to = 3;
   */
  to?: TreePos;

  /**
   * @generated from field: map<string, string> attributes = 4;
   */
  attributes: { [key: string]: string };

  /**
   * @generated from field: yorkie.v1.TimeTicket executed_at = 5;
   */
  executedAt?: TimeTicket;

  /**
   * @generated from field: repeated string attributes_to_remove = 6;
   */
  attributesToRemove: string[];

  /**
   * deprecated
   *
   * @generated from field: map<string, yorkie.v1.TimeTicket> created_at_map_by_actor = 7;
   */
  createdAtMapByActor: { [key: string]: TimeTicket };
};

/**
 * Describes the message yorkie.v1.Operation.TreeStyle.
 * Use `create(Operation_TreeStyleSchema)` to create a new message.
 */
export const Operation_TreeStyleSchema: GenMessage<Operation_TreeStyle> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 5, 8);

/**
 * @generated from message yorkie.v1.Operation.ArraySet
 */
export type Operation_ArraySet = Message<"yorkie.v1.Operation.ArraySet"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket parent_created_at = 1;
   */
  parentCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 2;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.JSONElementSimple value = 3;
   */
  value?: JSONElementSimple;

  /**
   * @generated from field: yorkie.v1.TimeTicket executed_at = 4;
   */
  executedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.Operation.ArraySet.
 * Use `create(Operation_ArraySetSchema)` to create a new message.
 */
export const Operation_ArraySetSchema: GenMessage<Operation_ArraySet> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 5, 9);

/**
 * @generated from message yorkie.v1.JSONElementSimple
 */
export type JSONElementSimple = Message<"yorkie.v1.JSONElementSimple"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 1;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket moved_at = 2;
   */
  movedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket removed_at = 3;
   */
  removedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.ValueType type = 4;
   */
  type: ValueType;

  /**
   * @generated from field: bytes value = 5;
   */
  value: Uint8Array;
};

/**
 * Describes the message yorkie.v1.JSONElementSimple.
 * Use `create(JSONElementSimpleSchema)` to create a new message.
 */
export const JSONElementSimpleSchema: GenMessage<JSONElementSimple> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 6);

/**
 * @generated from message yorkie.v1.JSONElement
 */
export type JSONElement = Message<"yorkie.v1.JSONElement"> & {
  /**
   * @generated from oneof yorkie.v1.JSONElement.body
   */
  body: {
    /**
     * @generated from field: yorkie.v1.JSONElement.JSONObject json_object = 1;
     */
    value: JSONElement_JSONObject;
    case: "jsonObject";
  } | {
    /**
     * @generated from field: yorkie.v1.JSONElement.JSONArray json_array = 2;
     */
    value: JSONElement_JSONArray;
    case: "jsonArray";
  } | {
    /**
     * @generated from field: yorkie.v1.JSONElement.Primitive primitive = 3;
     */
    value: JSONElement_Primitive;
    case: "primitive";
  } | {
    /**
     * @generated from field: yorkie.v1.JSONElement.Text text = 5;
     */
    value: JSONElement_Text;
    case: "text";
  } | {
    /**
     * @generated from field: yorkie.v1.JSONElement.Counter counter = 6;
     */
    value: JSONElement_Counter;
    case: "counter";
  } | {
    /**
     * @generated from field: yorkie.v1.JSONElement.Tree tree = 7;
     */
    value: JSONElement_Tree;
    case: "tree";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message yorkie.v1.JSONElement.
 * Use `create(JSONElementSchema)` to create a new message.
 */
export const JSONElementSchema: GenMessage<JSONElement> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 7);

/**
 * @generated from message yorkie.v1.JSONElement.JSONObject
 */
export type JSONElement_JSONObject = Message<"yorkie.v1.JSONElement.JSONObject"> & {
  /**
   * @generated from field: repeated yorkie.v1.RHTNode nodes = 1;
   */
  nodes: RHTNode[];

  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 2;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket moved_at = 3;
   */
  movedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket removed_at = 4;
   */
  removedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.JSONElement.JSONObject.
 * Use `create(JSONElement_JSONObjectSchema)` to create a new message.
 */
export const JSONElement_JSONObjectSchema: GenMessage<JSONElement_JSONObject> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 7, 0);

/**
 * @generated from message yorkie.v1.JSONElement.JSONArray
 */
export type JSONElement_JSONArray = Message<"yorkie.v1.JSONElement.JSONArray"> & {
  /**
   * @generated from field: repeated yorkie.v1.RGANode nodes = 1;
   */
  nodes: RGANode[];

  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 2;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket moved_at = 3;
   */
  movedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket removed_at = 4;
   */
  removedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.JSONElement.JSONArray.
 * Use `create(JSONElement_JSONArraySchema)` to create a new message.
 */
export const JSONElement_JSONArraySchema: GenMessage<JSONElement_JSONArray> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 7, 1);

/**
 * @generated from message yorkie.v1.JSONElement.Primitive
 */
export type JSONElement_Primitive = Message<"yorkie.v1.JSONElement.Primitive"> & {
  /**
   * @generated from field: yorkie.v1.ValueType type = 1;
   */
  type: ValueType;

  /**
   * @generated from field: bytes value = 2;
   */
  value: Uint8Array;

  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 3;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket moved_at = 4;
   */
  movedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket removed_at = 5;
   */
  removedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.JSONElement.Primitive.
 * Use `create(JSONElement_PrimitiveSchema)` to create a new message.
 */
export const JSONElement_PrimitiveSchema: GenMessage<JSONElement_Primitive> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 7, 2);

/**
 * @generated from message yorkie.v1.JSONElement.Text
 */
export type JSONElement_Text = Message<"yorkie.v1.JSONElement.Text"> & {
  /**
   * @generated from field: repeated yorkie.v1.TextNode nodes = 1;
   */
  nodes: TextNode[];

  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 2;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket moved_at = 3;
   */
  movedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket removed_at = 4;
   */
  removedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.JSONElement.Text.
 * Use `create(JSONElement_TextSchema)` to create a new message.
 */
export const JSONElement_TextSchema: GenMessage<JSONElement_Text> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 7, 3);

/**
 * @generated from message yorkie.v1.JSONElement.Counter
 */
export type JSONElement_Counter = Message<"yorkie.v1.JSONElement.Counter"> & {
  /**
   * @generated from field: yorkie.v1.ValueType type = 1;
   */
  type: ValueType;

  /**
   * @generated from field: bytes value = 2;
   */
  value: Uint8Array;

  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 3;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket moved_at = 4;
   */
  movedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket removed_at = 5;
   */
  removedAt?: TimeTicket;

  /**
   * @generated from field: bytes hll_registers = 7;
   */
  hllRegisters: Uint8Array;
};

/**
 * Describes the message yorkie.v1.JSONElement.Counter.
 * Use `create(JSONElement_CounterSchema)` to create a new message.
 */
export const JSONElement_CounterSchema: GenMessage<JSONElement_Counter> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 7, 4);

/**
 * @generated from message yorkie.v1.JSONElement.Tree
 */
export type JSONElement_Tree = Message<"yorkie.v1.JSONElement.Tree"> & {
  /**
   * @generated from field: repeated yorkie.v1.TreeNode nodes = 1;
   */
  nodes: TreeNode[];

  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 2;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket moved_at = 3;
   */
  movedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket removed_at = 4;
   */
  removedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.JSONElement.Tree.
 * Use `create(JSONElement_TreeSchema)` to create a new message.
 */
export const JSONElement_TreeSchema: GenMessage<JSONElement_Tree> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 7, 5);

/**
 * @generated from message yorkie.v1.RHTNode
 */
export type RHTNode = Message<"yorkie.v1.RHTNode"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: yorkie.v1.JSONElement element = 2;
   */
  element?: JSONElement;
};

/**
 * Describes the message yorkie.v1.RHTNode.
 * Use `create(RHTNodeSchema)` to create a new message.
 */
export const RHTNodeSchema: GenMessage<RHTNode> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 8);

/**
 * @generated from message yorkie.v1.RGANode
 */
export type RGANode = Message<"yorkie.v1.RGANode"> & {
  /**
   * @generated from field: yorkie.v1.RGANode next = 1;
   */
  next?: RGANode;

  /**
   * @generated from field: yorkie.v1.JSONElement element = 2;
   */
  element?: JSONElement;

  /**
   * @generated from field: yorkie.v1.TimeTicket position_created_at = 3;
   */
  positionCreatedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket position_moved_at = 4;
   */
  positionMovedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TimeTicket position_removed_at = 5;
   */
  positionRemovedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.RGANode.
 * Use `create(RGANodeSchema)` to create a new message.
 */
export const RGANodeSchema: GenMessage<RGANode> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 9);

/**
 * @generated from message yorkie.v1.NodeAttr
 */
export type NodeAttr = Message<"yorkie.v1.NodeAttr"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: yorkie.v1.TimeTicket updated_at = 2;
   */
  updatedAt?: TimeTicket;

  /**
   * @generated from field: bool is_removed = 3;
   */
  isRemoved: boolean;
};

/**
 * Describes the message yorkie.v1.NodeAttr.
 * Use `create(NodeAttrSchema)` to create a new message.
 */
export const NodeAttrSchema: GenMessage<NodeAttr> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 10);

/**
 * @generated from message yorkie.v1.TextNode
 */
export type TextNode = Message<"yorkie.v1.TextNode"> & {
  /**
   * @generated from field: yorkie.v1.TextNodeID id = 1;
   */
  id?: TextNodeID;

  /**
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * @generated from field: yorkie.v1.TimeTicket removed_at = 3;
   */
  removedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TextNodeID ins_prev_id = 4;
   */
  insPrevId?: TextNodeID;

  /**
   * @generated from field: map<string, yorkie.v1.NodeAttr> attributes = 5;
   */
  attributes: { [key: string]: NodeAttr };
};

/**
 * Describes the message yorkie.v1.TextNode.
 * Use `create(TextNodeSchema)` to create a new message.
 */
export const TextNodeSchema: GenMessage<TextNode> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 11);

/**
 * @generated from message yorkie.v1.TextNodeID
 */
export type TextNodeID = Message<"yorkie.v1.TextNodeID"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 1;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: int32 offset = 2;
   */
  offset: number;
};

/**
 * Describes the message yorkie.v1.TextNodeID.
 * Use `create(TextNodeIDSchema)` to create a new message.
 */
export const TextNodeIDSchema: GenMessage<TextNodeID> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 12);

/**
 * @generated from message yorkie.v1.TreeNode
 */
export type TreeNode = Message<"yorkie.v1.TreeNode"> & {
  /**
   * @generated from field: yorkie.v1.TreeNodeID id = 1;
   */
  id?: TreeNodeID;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: yorkie.v1.TimeTicket removed_at = 4;
   */
  removedAt?: TimeTicket;

  /**
   * @generated from field: yorkie.v1.TreeNodeID ins_prev_id = 5;
   */
  insPrevId?: TreeNodeID;

  /**
   * @generated from field: yorkie.v1.TreeNodeID ins_next_id = 6;
   */
  insNextId?: TreeNodeID;

  /**
   * @generated from field: int32 depth = 7;
   */
  depth: number;

  /**
   * @generated from field: map<string, yorkie.v1.NodeAttr> attributes = 8;
   */
  attributes: { [key: string]: NodeAttr };

  /**
   * merged_from is set when this node was moved to a new parent by a
   * concurrent merge. It points to the source parent's ID.
   *
   * @generated from field: yorkie.v1.TreeNodeID merged_from = 9;
   */
  mergedFrom?: TreeNodeID;

  /**
   * merged_at records the immutable ticket of the merge operation.
   * Stored alongside merged_from because the source parent's removed_at
   * may be overwritten by later LWW tombstones and thus cannot serve as
   * the merge-time causal boundary for SplitElement.
   *
   * @generated from field: yorkie.v1.TimeTicket merged_at = 10;
   */
  mergedAt?: TimeTicket;
};

/**
 * Describes the message yorkie.v1.TreeNode.
 * Use `create(TreeNodeSchema)` to create a new message.
 */
export const TreeNodeSchema: GenMessage<TreeNode> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 13);

/**
 * @generated from message yorkie.v1.TreeNodes
 */
export type TreeNodes = Message<"yorkie.v1.TreeNodes"> & {
  /**
   * @generated from field: repeated yorkie.v1.TreeNode content = 1;
   */
  content: TreeNode[];
};

/**
 * Describes the message yorkie.v1.TreeNodes.
 * Use `create(TreeNodesSchema)` to create a new message.
 */
export const TreeNodesSchema: GenMessage<TreeNodes> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 14);

/**
 * @generated from message yorkie.v1.TreeNodeID
 */
export type TreeNodeID = Message<"yorkie.v1.TreeNodeID"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 1;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: int32 offset = 2;
   */
  offset: number;
};

/**
 * Describes the message yorkie.v1.TreeNodeID.
 * Use `create(TreeNodeIDSchema)` to create a new message.
 */
export const TreeNodeIDSchema: GenMessage<TreeNodeID> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 15);

/**
 * @generated from message yorkie.v1.TreePos
 */
export type TreePos = Message<"yorkie.v1.TreePos"> & {
  /**
   * @generated from field: yorkie.v1.TreeNodeID parent_id = 1;
   */
  parentId?: TreeNodeID;

  /**
   * @generated from field: yorkie.v1.TreeNodeID left_sibling_id = 2;
   */
  leftSiblingId?: TreeNodeID;
};

/**
 * Describes the message yorkie.v1.TreePos.
 * Use `create(TreePosSchema)` to create a new message.
 */
export const TreePosSchema: GenMessage<TreePos> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 16);

/**
 * @generated from message yorkie.v1.User
 */
export type User = Message<"yorkie.v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string auth_provider = 2;
   */
  authProvider: string;

  /**
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message yorkie.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 17);

/**
 * @generated from message yorkie.v1.Member
 */
export type Member = Message<"yorkie.v1.Member"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string username = 4;
   */
  username: string;

  /**
   * @generated from field: string role = 5;
   */
  role: string;

  /**
   * @generated from field: google.protobuf.Timestamp invited_at = 6;
   */
  invitedAt?: Timestamp;
};

/**
 * Describes the message yorkie.v1.Member.
 * Use `create(MemberSchema)` to create a new message.
 */
export const MemberSchema: GenMessage<Member> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 18);

/**
 * @generated from message yorkie.v1.Project
 */
export type Project = Message<"yorkie.v1.Project"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string public_key = 3;
   */
  publicKey: string;

  /**
   * @generated from field: string secret_key = 4;
   */
  secretKey: string;

  /**
   * @generated from field: string auth_webhook_url = 5;
   */
  authWebhookUrl: string;

  /**
   * @generated from field: repeated string auth_webhook_methods = 6;
   */
  authWebhookMethods: string[];

  /**
   * @generated from field: uint64 auth_webhook_max_retries = 17;
   */
  authWebhookMaxRetries: bigint;

  /**
   * @generated from field: string auth_webhook_min_wait_interval = 18;
   */
  authWebhookMinWaitInterval: string;

  /**
   * @generated from field: string auth_webhook_max_wait_interval = 19;
   */
  authWebhookMaxWaitInterval: string;

  /**
   * @generated from field: string auth_webhook_request_timeout = 20;
   */
  authWebhookRequestTimeout: string;

  /**
   * @generated from field: string event_webhook_url = 7;
   */
  eventWebhookUrl: string;

  /**
   * @generated from field: repeated string event_webhook_events = 8;
   */
  eventWebhookEvents: string[];

  /**
   * @generated from field: uint64 event_webhook_max_retries = 21;
   */
  eventWebhookMaxRetries: bigint;

  /**
   * @generated from field: string event_webhook_min_wait_interval = 22;
   */
  eventWebhookMinWaitInterval: string;

  /**
   * @generated from field: string event_webhook_max_wait_interval = 23;
   */
  eventWebhookMaxWaitInterval: string;

  /**
   * @generated from field: string event_webhook_request_timeout = 24;
   */
  eventWebhookRequestTimeout: string;

  /**
   * @generated from field: string client_deactivate_threshold = 9;
   */
  clientDeactivateThreshold: string;

  /**
   * @generated from field: int64 snapshot_threshold = 25;
   */
  snapshotThreshold: bigint;

  /**
   * @generated from field: int64 snapshot_interval = 26;
   */
  snapshotInterval: bigint;

  /**
   * @generated from field: int32 max_subscribers_per_document = 10;
   */
  maxSubscribersPerDocument: number;

  /**
   * @generated from field: int32 max_attachments_per_document = 11;
   */
  maxAttachmentsPerDocument: number;

  /**
   * @generated from field: int32 max_size_per_document = 15;
   */
  maxSizePerDocument: number;

  /**
   * @generated from field: bool remove_on_detach = 16;
   */
  removeOnDetach: boolean;

  /**
   * @generated from field: bool auto_revision_enabled = 27;
   */
  autoRevisionEnabled: boolean;

  /**
   * @generated from field: repeated string allowed_origins = 14;
   */
  allowedOrigins: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message yorkie.v1.Project.
 * Use `create(ProjectSchema)` to create a new message.
 */
export const ProjectSchema: GenMessage<Project> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 19);

/**
 * @generated from message yorkie.v1.MetricPoint
 */
export type MetricPoint = Message<"yorkie.v1.MetricPoint"> & {
  /**
   * @generated from field: int64 timestamp = 1;
   */
  timestamp: bigint;

  /**
   * @generated from field: int32 value = 2;
   */
  value: number;
};

/**
 * Describes the message yorkie.v1.MetricPoint.
 * Use `create(MetricPointSchema)` to create a new message.
 */
export const MetricPointSchema: GenMessage<MetricPoint> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 20);

/**
 * @generated from message yorkie.v1.UpdatableProjectFields
 */
export type UpdatableProjectFields = Message<"yorkie.v1.UpdatableProjectFields"> & {
  /**
   * @generated from field: google.protobuf.StringValue name = 1;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue auth_webhook_url = 2;
   */
  authWebhookUrl?: string;

  /**
   * @generated from field: yorkie.v1.UpdatableProjectFields.AuthWebhookMethods auth_webhook_methods = 3;
   */
  authWebhookMethods?: UpdatableProjectFields_AuthWebhookMethods;

  /**
   * @generated from field: google.protobuf.UInt64Value auth_webhook_max_retries = 12;
   */
  authWebhookMaxRetries?: bigint;

  /**
   * @generated from field: google.protobuf.StringValue auth_webhook_min_wait_interval = 13;
   */
  authWebhookMinWaitInterval?: string;

  /**
   * @generated from field: google.protobuf.StringValue auth_webhook_max_wait_interval = 14;
   */
  authWebhookMaxWaitInterval?: string;

  /**
   * @generated from field: google.protobuf.StringValue auth_webhook_request_timeout = 15;
   */
  authWebhookRequestTimeout?: string;

  /**
   * @generated from field: google.protobuf.StringValue event_webhook_url = 4;
   */
  eventWebhookUrl?: string;

  /**
   * @generated from field: yorkie.v1.UpdatableProjectFields.EventWebhookEvents event_webhook_events = 5;
   */
  eventWebhookEvents?: UpdatableProjectFields_EventWebhookEvents;

  /**
   * @generated from field: google.protobuf.UInt64Value event_webhook_max_retries = 16;
   */
  eventWebhookMaxRetries?: bigint;

  /**
   * @generated from field: google.protobuf.StringValue event_webhook_min_wait_interval = 17;
   */
  eventWebhookMinWaitInterval?: string;

  /**
   * @generated from field: google.protobuf.StringValue event_webhook_max_wait_interval = 18;
   */
  eventWebhookMaxWaitInterval?: string;

  /**
   * @generated from field: google.protobuf.StringValue event_webhook_request_timeout = 19;
   */
  eventWebhookRequestTimeout?: string;

  /**
   * @generated from field: google.protobuf.Int64Value snapshot_threshold = 20;
   */
  snapshotThreshold?: bigint;

  /**
   * @generated from field: google.protobuf.Int64Value snapshot_interval = 21;
   */
  snapshotInterval?: bigint;

  /**
   * @generated from field: google.protobuf.StringValue client_deactivate_threshold = 6;
   */
  clientDeactivateThreshold?: string;

  /**
   * @generated from field: google.protobuf.Int32Value max_subscribers_per_document = 7;
   */
  maxSubscribersPerDocument?: number;

  /**
   * @generated from field: google.protobuf.Int32Value max_attachments_per_document = 8;
   */
  maxAttachmentsPerDocument?: number;

  /**
   * @generated from field: google.protobuf.Int32Value max_size_per_document = 10;
   */
  maxSizePerDocument?: number;

  /**
   * @generated from field: google.protobuf.BoolValue remove_on_detach = 11;
   */
  removeOnDetach?: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue auto_revision_enabled = 22;
   */
  autoRevisionEnabled?: boolean;

  /**
   * @generated from field: yorkie.v1.UpdatableProjectFields.AllowedOrigins allowed_origins = 9;
   */
  allowedOrigins?: UpdatableProjectFields_AllowedOrigins;
};

/**
 * Describes the message yorkie.v1.UpdatableProjectFields.
 * Use `create(UpdatableProjectFieldsSchema)` to create a new message.
 */
export const UpdatableProjectFieldsSchema: GenMessage<UpdatableProjectFields> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 21);

/**
 * @generated from message yorkie.v1.UpdatableProjectFields.AuthWebhookMethods
 */
export type UpdatableProjectFields_AuthWebhookMethods = Message<"yorkie.v1.UpdatableProjectFields.AuthWebhookMethods"> & {
  /**
   * @generated from field: repeated string methods = 1;
   */
  methods: string[];
};

/**
 * Describes the message yorkie.v1.UpdatableProjectFields.AuthWebhookMethods.
 * Use `create(UpdatableProjectFields_AuthWebhookMethodsSchema)` to create a new message.
 */
export const UpdatableProjectFields_AuthWebhookMethodsSchema: GenMessage<UpdatableProjectFields_AuthWebhookMethods> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 21, 0);

/**
 * @generated from message yorkie.v1.UpdatableProjectFields.EventWebhookEvents
 */
export type UpdatableProjectFields_EventWebhookEvents = Message<"yorkie.v1.UpdatableProjectFields.EventWebhookEvents"> & {
  /**
   * @generated from field: repeated string events = 1;
   */
  events: string[];
};

/**
 * Describes the message yorkie.v1.UpdatableProjectFields.EventWebhookEvents.
 * Use `create(UpdatableProjectFields_EventWebhookEventsSchema)` to create a new message.
 */
export const UpdatableProjectFields_EventWebhookEventsSchema: GenMessage<UpdatableProjectFields_EventWebhookEvents> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 21, 1);

/**
 * @generated from message yorkie.v1.UpdatableProjectFields.AllowedOrigins
 */
export type UpdatableProjectFields_AllowedOrigins = Message<"yorkie.v1.UpdatableProjectFields.AllowedOrigins"> & {
  /**
   * @generated from field: repeated string origins = 1;
   */
  origins: string[];
};

/**
 * Describes the message yorkie.v1.UpdatableProjectFields.AllowedOrigins.
 * Use `create(UpdatableProjectFields_AllowedOriginsSchema)` to create a new message.
 */
export const UpdatableProjectFields_AllowedOriginsSchema: GenMessage<UpdatableProjectFields_AllowedOrigins> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 21, 2);

/**
 * @generated from message yorkie.v1.DocumentSummary
 */
export type DocumentSummary = Message<"yorkie.v1.DocumentSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: string root = 3;
   */
  root: string;

  /**
   * @generated from field: int32 attached_clients = 7;
   */
  attachedClients: number;

  /**
   * @generated from field: yorkie.v1.DocSize document_size = 8;
   */
  documentSize?: DocSize;

  /**
   * @generated from field: string schema_key = 9;
   */
  schemaKey: string;

  /**
   * @generated from field: map<string, yorkie.v1.Presence> presences = 10;
   */
  presences: { [key: string]: Presence };

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp accessed_at = 5;
   */
  accessedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message yorkie.v1.DocumentSummary.
 * Use `create(DocumentSummarySchema)` to create a new message.
 */
export const DocumentSummarySchema: GenMessage<DocumentSummary> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 22);

/**
 * @generated from message yorkie.v1.PresenceChange
 */
export type PresenceChange = Message<"yorkie.v1.PresenceChange"> & {
  /**
   * @generated from field: yorkie.v1.PresenceChange.ChangeType type = 1;
   */
  type: PresenceChange_ChangeType;

  /**
   * @generated from field: yorkie.v1.Presence presence = 2;
   */
  presence?: Presence;
};

/**
 * Describes the message yorkie.v1.PresenceChange.
 * Use `create(PresenceChangeSchema)` to create a new message.
 */
export const PresenceChangeSchema: GenMessage<PresenceChange> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 23);

/**
 * @generated from enum yorkie.v1.PresenceChange.ChangeType
 */
export enum PresenceChange_ChangeType {
  /**
   * @generated from enum value: CHANGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHANGE_TYPE_PUT = 1;
   */
  PUT = 1,

  /**
   * @generated from enum value: CHANGE_TYPE_DELETE = 2;
   */
  DELETE = 2,

  /**
   * @generated from enum value: CHANGE_TYPE_CLEAR = 3;
   */
  CLEAR = 3,
}

/**
 * Describes the enum yorkie.v1.PresenceChange.ChangeType.
 */
export const PresenceChange_ChangeTypeSchema: GenEnum<PresenceChange_ChangeType> = /*@__PURE__*/
  enumDesc(file_yorkie_v1_resources, 23, 0);

/**
 * @generated from message yorkie.v1.Presence
 */
export type Presence = Message<"yorkie.v1.Presence"> & {
  /**
   * @generated from field: map<string, string> data = 1;
   */
  data: { [key: string]: string };
};

/**
 * Describes the message yorkie.v1.Presence.
 * Use `create(PresenceSchema)` to create a new message.
 */
export const PresenceSchema: GenMessage<Presence> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 24);

/**
 * @generated from message yorkie.v1.ChannelSummary
 */
export type ChannelSummary = Message<"yorkie.v1.ChannelSummary"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: int32 session_count = 2;
   */
  sessionCount: number;
};

/**
 * Describes the message yorkie.v1.ChannelSummary.
 * Use `create(ChannelSummarySchema)` to create a new message.
 */
export const ChannelSummarySchema: GenMessage<ChannelSummary> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 25);

/**
 * @generated from message yorkie.v1.Checkpoint
 */
export type Checkpoint = Message<"yorkie.v1.Checkpoint"> & {
  /**
   * @generated from field: int64 server_seq = 1;
   */
  serverSeq: bigint;

  /**
   * @generated from field: uint32 client_seq = 2;
   */
  clientSeq: number;
};

/**
 * Describes the message yorkie.v1.Checkpoint.
 * Use `create(CheckpointSchema)` to create a new message.
 */
export const CheckpointSchema: GenMessage<Checkpoint> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 26);

/**
 * @generated from message yorkie.v1.TextNodePos
 */
export type TextNodePos = Message<"yorkie.v1.TextNodePos"> & {
  /**
   * @generated from field: yorkie.v1.TimeTicket created_at = 1;
   */
  createdAt?: TimeTicket;

  /**
   * @generated from field: int32 offset = 2;
   */
  offset: number;

  /**
   * @generated from field: int32 relative_offset = 3;
   */
  relativeOffset: number;
};

/**
 * Describes the message yorkie.v1.TextNodePos.
 * Use `create(TextNodePosSchema)` to create a new message.
 */
export const TextNodePosSchema: GenMessage<TextNodePos> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 27);

/**
 * @generated from message yorkie.v1.TimeTicket
 */
export type TimeTicket = Message<"yorkie.v1.TimeTicket"> & {
  /**
   * @generated from field: int64 lamport = 1;
   */
  lamport: bigint;

  /**
   * @generated from field: uint32 delimiter = 2;
   */
  delimiter: number;

  /**
   * @generated from field: bytes actor_id = 3;
   */
  actorId: Uint8Array;
};

/**
 * Describes the message yorkie.v1.TimeTicket.
 * Use `create(TimeTicketSchema)` to create a new message.
 */
export const TimeTicketSchema: GenMessage<TimeTicket> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 28);

/**
 * @generated from message yorkie.v1.DocEventBody
 */
export type DocEventBody = Message<"yorkie.v1.DocEventBody"> & {
  /**
   * @generated from field: string topic = 1;
   */
  topic: string;

  /**
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;
};

/**
 * Describes the message yorkie.v1.DocEventBody.
 * Use `create(DocEventBodySchema)` to create a new message.
 */
export const DocEventBodySchema: GenMessage<DocEventBody> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 29);

/**
 * @generated from message yorkie.v1.DocEvent
 */
export type DocEvent = Message<"yorkie.v1.DocEvent"> & {
  /**
   * @generated from field: yorkie.v1.DocEventType type = 1;
   */
  type: DocEventType;

  /**
   * @generated from field: string publisher = 2;
   */
  publisher: string;

  /**
   * @generated from field: yorkie.v1.DocEventBody body = 3;
   */
  body?: DocEventBody;
};

/**
 * Describes the message yorkie.v1.DocEvent.
 * Use `create(DocEventSchema)` to create a new message.
 */
export const DocEventSchema: GenMessage<DocEvent> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 30);

/**
 * @generated from message yorkie.v1.ChannelEvent
 */
export type ChannelEvent = Message<"yorkie.v1.ChannelEvent"> & {
  /**
   * @generated from field: yorkie.v1.ChannelEvent.Type type = 1;
   */
  type: ChannelEvent_Type;

  /**
   * @generated from field: string publisher = 2;
   */
  publisher: string;

  /**
   * @generated from field: int64 session_count = 3;
   */
  sessionCount: bigint;

  /**
   * @generated from field: int64 seq = 4;
   */
  seq: bigint;

  /**
   * @generated from field: string topic = 5;
   */
  topic: string;

  /**
   * @generated from field: bytes payload = 6;
   */
  payload: Uint8Array;
};

/**
 * Describes the message yorkie.v1.ChannelEvent.
 * Use `create(ChannelEventSchema)` to create a new message.
 */
export const ChannelEventSchema: GenMessage<ChannelEvent> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 31);

/**
 * @generated from enum yorkie.v1.ChannelEvent.Type
 */
export enum ChannelEvent_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TYPE_PRESENCE = 1;
   */
  PRESENCE = 1,

  /**
   * @generated from enum value: TYPE_BROADCAST = 2;
   */
  BROADCAST = 2,
}

/**
 * Describes the enum yorkie.v1.ChannelEvent.Type.
 */
export const ChannelEvent_TypeSchema: GenEnum<ChannelEvent_Type> = /*@__PURE__*/
  enumDesc(file_yorkie_v1_resources, 31, 0);

/**
 * @generated from message yorkie.v1.DataSize
 */
export type DataSize = Message<"yorkie.v1.DataSize"> & {
  /**
   * @generated from field: int32 data = 1;
   */
  data: number;

  /**
   * @generated from field: int32 meta = 2;
   */
  meta: number;
};

/**
 * Describes the message yorkie.v1.DataSize.
 * Use `create(DataSizeSchema)` to create a new message.
 */
export const DataSizeSchema: GenMessage<DataSize> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 32);

/**
 * @generated from message yorkie.v1.DocSize
 */
export type DocSize = Message<"yorkie.v1.DocSize"> & {
  /**
   * @generated from field: yorkie.v1.DataSize live = 1;
   */
  live?: DataSize;

  /**
   * @generated from field: yorkie.v1.DataSize gc = 2;
   */
  gc?: DataSize;
};

/**
 * Describes the message yorkie.v1.DocSize.
 * Use `create(DocSizeSchema)` to create a new message.
 */
export const DocSizeSchema: GenMessage<DocSize> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 33);

/**
 * @generated from message yorkie.v1.Schema
 */
export type Schema = Message<"yorkie.v1.Schema"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 version = 3;
   */
  version: number;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: repeated yorkie.v1.Rule rules = 5;
   */
  rules: Rule[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message yorkie.v1.Schema.
 * Use `create(SchemaSchema)` to create a new message.
 */
export const SchemaSchema: GenMessage<Schema> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 34);

/**
 * @generated from message yorkie.v1.TreeNodeRule
 */
export type TreeNodeRule = Message<"yorkie.v1.TreeNodeRule"> & {
  /**
   * @generated from field: string node_type = 1;
   */
  nodeType: string;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: string marks = 3;
   */
  marks: string;

  /**
   * @generated from field: string group = 4;
   */
  group: string;
};

/**
 * Describes the message yorkie.v1.TreeNodeRule.
 * Use `create(TreeNodeRuleSchema)` to create a new message.
 */
export const TreeNodeRuleSchema: GenMessage<TreeNodeRule> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 35);

/**
 * @generated from message yorkie.v1.Rule
 */
export type Rule = Message<"yorkie.v1.Rule"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: repeated yorkie.v1.TreeNodeRule tree_nodes = 3;
   */
  treeNodes: TreeNodeRule[];
};

/**
 * Describes the message yorkie.v1.Rule.
 * Use `create(RuleSchema)` to create a new message.
 */
export const RuleSchema: GenMessage<Rule> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 36);

/**
 * @generated from message yorkie.v1.RevisionSummary
 */
export type RevisionSummary = Message<"yorkie.v1.RevisionSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string snapshot = 4;
   */
  snapshot: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message yorkie.v1.RevisionSummary.
 * Use `create(RevisionSummarySchema)` to create a new message.
 */
export const RevisionSummarySchema: GenMessage<RevisionSummary> = /*@__PURE__*/
  messageDesc(file_yorkie_v1_resources, 37);

/**
 * @generated from enum yorkie.v1.ValueType
 */
export enum ValueType {
  /**
   * @generated from enum value: VALUE_TYPE_NULL = 0;
   */
  NULL = 0,

  /**
   * @generated from enum value: VALUE_TYPE_BOOLEAN = 1;
   */
  BOOLEAN = 1,

  /**
   * @generated from enum value: VALUE_TYPE_INTEGER = 2;
   */
  INTEGER = 2,

  /**
   * @generated from enum value: VALUE_TYPE_LONG = 3;
   */
  LONG = 3,

  /**
   * @generated from enum value: VALUE_TYPE_DOUBLE = 4;
   */
  DOUBLE = 4,

  /**
   * @generated from enum value: VALUE_TYPE_STRING = 5;
   */
  STRING = 5,

  /**
   * @generated from enum value: VALUE_TYPE_BYTES = 6;
   */
  BYTES = 6,

  /**
   * @generated from enum value: VALUE_TYPE_DATE = 7;
   */
  DATE = 7,

  /**
   * @generated from enum value: VALUE_TYPE_JSON_OBJECT = 8;
   */
  JSON_OBJECT = 8,

  /**
   * @generated from enum value: VALUE_TYPE_JSON_ARRAY = 9;
   */
  JSON_ARRAY = 9,

  /**
   * @generated from enum value: VALUE_TYPE_TEXT = 10;
   */
  TEXT = 10,

  /**
   * @generated from enum value: VALUE_TYPE_INTEGER_CNT = 11;
   */
  INTEGER_CNT = 11,

  /**
   * @generated from enum value: VALUE_TYPE_LONG_CNT = 12;
   */
  LONG_CNT = 12,

  /**
   * @generated from enum value: VALUE_TYPE_TREE = 13;
   */
  TREE = 13,

  /**
   * @generated from enum value: VALUE_TYPE_INTEGER_DEDUP_CNT = 14;
   */
  INTEGER_DEDUP_CNT = 14,
}

/**
 * Describes the enum yorkie.v1.ValueType.
 */
export const ValueTypeSchema: GenEnum<ValueType> = /*@__PURE__*/
  enumDesc(file_yorkie_v1_resources, 0);

/**
 * @generated from enum yorkie.v1.DocEventType
 */
export enum DocEventType {
  /**
   * @generated from enum value: DOC_EVENT_TYPE_DOCUMENT_CHANGED = 0;
   */
  DOCUMENT_CHANGED = 0,

  /**
   * @generated from enum value: DOC_EVENT_TYPE_DOCUMENT_WATCHED = 1;
   */
  DOCUMENT_WATCHED = 1,

  /**
   * @generated from enum value: DOC_EVENT_TYPE_DOCUMENT_UNWATCHED = 2;
   */
  DOCUMENT_UNWATCHED = 2,

  /**
   * @generated from enum value: DOC_EVENT_TYPE_DOCUMENT_BROADCAST = 3;
   */
  DOCUMENT_BROADCAST = 3,
}

/**
 * Describes the enum yorkie.v1.DocEventType.
 */
export const DocEventTypeSchema: GenEnum<DocEventType> = /*@__PURE__*/
  enumDesc(file_yorkie_v1_resources, 1);

